// Redux Action Types
import { SET_TRANSITION } from '../actions/types';
// Initial State
const initialState = null;

export default function (state = initialState, action) {
  if (action.type === SET_TRANSITION) return action.payload;
  return state;
}
